import { Injectable } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { map } from "rxjs/operators";

@Injectable()
export class RouteParamService {
	getQueryParam(route: ActivatedRoute, term: string) {
		return route.queryParams.pipe(map((data) => data[term]));
	}

	getRouteParam(route: ActivatedRoute, term: string) {
		return route.params.pipe(map((data) => data[term]));
	}
}
